import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { StudiesService } from 'src/app/services/studies/studies.service';
import { StudyPageService } from '../study-page.service';
import { STUDY_ATTRIBUTE_TO_SEARCH_ID } from '../../../constants/document';

import { getStudyDisplay, StudyDisplay } from './utils/get-study-display';
import { StudyPartialEditDialogContainerComponent } from '../../../components/study-partial-edit-dialog/study-partial-edit-dialog-container.component';
import { STUDY_EDIT_FIELD } from '../../../components/study-partial-edit-dialog/constants';
import { STUDY_STATUS } from '../../../constants/statuses';

@Component({
  selector: 'app-study-info-page',
  styleUrls: ['./study-info-page.component.scss'],
  templateUrl: './study-info-page.component.html',
})
export class StudyInfoPageComponent implements OnInit {
  STUDY_EDIT_FIELD = STUDY_EDIT_FIELD;
  STUDY_STATUS = STUDY_STATUS;
  errorMessage: string;
  loading = false;
  study: StudyDisplay;

  constructor(
    private route: ActivatedRoute,
    private studiesService: StudiesService,
    private studyPageService: StudyPageService,
    public editDialog: MatDialog,
  ) {}

  ngOnInit() {
    const studyId = Number(this.route.parent.snapshot.params['id']);
    this.loadStudy(studyId);
  }

  get canEdit() {
    return this.study.status === STUDY_STATUS.SENT_TO_INFORM;
  }

  async loadStudy(studyId: number) {
    this.loading = true;

    const { error, data } = await this.studiesService.getStudy(studyId);

    this.loading = false;
    this.errorMessage = error?.message || '';
    this.study = data && getStudyDisplay(data);
  }

  searchField(field: string) {
    this.studyPageService.search(STUDY_ATTRIBUTE_TO_SEARCH_ID[field]);
  }

  openDialog(field: STUDY_EDIT_FIELD) {
    const dialogRef = this.editDialog.open(
      StudyPartialEditDialogContainerComponent,
      {
        data: {
          field,
          study: {
            id: this.study.id,
            sglCode: this.study.sglCode,
            status: this.study.status,
          },
        },
        disableClose: true,
      },
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.fieldName) {
        this.study[result.fieldName] = result.fieldValue;
        this.study = this.study && getStudyDisplay(this.study);
      }
    });
  }
}
